export default "__VITE_ASSET__FfrF1g7k__"